var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.5,
    height: 14.5,
    viewBox: "0 0 14.5 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-5208247",
    transform: "translate(-100 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247814",
    "data-name": "Path 247814",
    d: "M774.47,102.829,771.64,100l-1.96,1.96,2.829,2.829Z",
    transform: "translate(-659.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247815",
    "data-name": "Path 247815",
    d: "M300,324.486l3.112-.283,5.356-5.356-2.829-2.829-5.356,5.356Z",
    transform: "translate(-197.1 -212.886)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247816",
    "data-name": "Path 247816",
    d: "M109.425,1001.45H100V1000h9.425Z",
    transform: "translate(0 -886.95)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.93d881674eebcb2ad59d3276316221a1.svg";
export { ForwardRef as ReactComponent };